import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import classNames from "classnames"
import { includes, keys, map, mapValues, pickBy, size } from "lodash"
import { DATE } from "helpers/shapes"
import { LOADING } from "helpers/data-statuses"
import Loading from "components/loading"
import Tooltip from "components/analyze-tooltip"
import CompareDownload from "components/compare-download"
import { getCurrentLocation } from "modules/comparison/selectors"
import { DATA, DOWNLOAD_FILENAME, ITEMS, POSITIONS_DISPLAY_TYPE, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import { getGraphData, getSingleDotGraph } from "./helper"
import LegendItem from "./legend-item"
import Chart from "./chart"
import "./style.scss"

function cleanUnmodeledAndDisabledChartData(data, items) {
  const itemIndexesToRemove = keys(pickBy(items, (item) => item.isUnmodeled || item.disabled))
  const newData = map(data, dataItem => mapValues(dataItem, (value, key) => includes(itemIndexesToRemove, key) ? null : value))
  return newData
}

class CompareChart extends Component {
  static propTypes = {
    data: DATA.isRequired,
    chartDownloadData: DATA,
    startDate: DATE,
    endDate: DATE,
    items: ITEMS.isRequired,
    setDate: PropTypes.func.isRequired,
    tooltipFormatter: PropTypes.func.isRequired,
    metricSelector: PropTypes.element.isRequired,
    status: PropTypes.string.isRequired,
    isOneDayGraph: PropTypes.bool.isRequired,
    fixedItemNumber: PropTypes.bool,
    fileName: DOWNLOAD_FILENAME,
    positionsDisplayType: POSITIONS_DISPLAY_TYPE,
    selectedView: PropTypes.string.isRequired,
    tableDownloadData: TABLE_DOWNLOAD_DATA,
    currentLocation: PropTypes.string.isRequired,
    percents: PropTypes.bool,
    noDownload: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      focusedChartLine: null,
    }
  }

  handleFocusChartLine = (focusedChartLine) => {
    this.setState({ focusedChartLine })
  }

  handleBlurChartLine = () => {
    this.setState({ focusedChartLine: null })
  }

  render() {
    const {
      data,
      items,
      metricSelector,
      tooltipFormatter,
      status,
      fixedItemNumber,
      fileName,
      selectedView,
      tableDownloadData,
      currentLocation,
      chartDownloadData,
      percents,
      noDownload,
    } = this.props

    const {
      focusedChartLine,
    } = this.state

    if (status === LOADING) {
      return <div className="components_charts_compare"><Loading /></div>
    } else if (!data.length) {
      return <div className="components_charts_compare no-data">No Data</div>
    } else {
      const cleanedChartDownloadData = cleanUnmodeledAndDisabledChartData(chartDownloadData || data, items)
      return <div className="components_charts_compare">
        <div className={classNames("legend", { "fixed-item-number": fixedItemNumber })}>
          <div>{metricSelector}</div>
          {map(items, (item, index) =>
            <LegendItem
              key={item.id}
              isLastLegendItem={index === size(items) - 1}
              {...item}
              focus={this.handleFocusChartLine}
              blur={this.handleBlurChartLine}
              focused={focusedChartLine}
            />,
          )}
          {!noDownload
            && <CompareDownload
              {...{
                fileName,
                selectedView,
                items,
                currentLocation,
                chartDownloadData: cleanedChartDownloadData,
                tableDownloadData,
                percents,
              }}
            />}
        </div>
        <Chart
          {...this.props}
          {...this.state}
          tooltip={<Tooltip data={data} items={items} focusedChartLine={focusedChartLine} formatter={tooltipFormatter} />}
          focusChartLine={this.handleFocusChartLine}
          blurChartLine={this.handleBlurChartLine}
        />
      </div>
    }
  }
}

const mapStateToProps = (state, props) => ({
  data: getGraphData(props),
  isOneDayGraph: getSingleDotGraph(props),
  currentLocation: getCurrentLocation(state, props),
})

export default connect(mapStateToProps)(CompareChart)
